module.exports = __webpack_public_path__ + "img/14f6f05.jpg";